const LS_URL_KEY = 'rasiCentralDbUrl';
const LS_KEY_KEY = 'rasiCentralDbApiKey';

/** API key default dari build — harus sama dengan RASITECH_API_KEY di server unified. */
const BUILTIN_API_KEY = typeof process !== 'undefined' && process.env?.RASITECH_CENTRAL_DB_API_KEY
  ? String(process.env.RASITECH_CENTRAL_DB_API_KEY).trim()
  : '';

export type CentralDbConfig = {
  baseUrl: string;
  apiKey: string;
};

function resolveBaseUrl(): string {
  const fromEnv = (typeof process !== 'undefined' && process.env?.RASITECH_CENTRAL_DB_URL
    ? String(process.env.RASITECH_CENTRAL_DB_URL)
    : '').trim().replace(/\/$/, '');

  if (fromEnv) return fromEnv;

  if (typeof localStorage !== 'undefined') {
    const lsUrl = localStorage.getItem(LS_URL_KEY)?.trim();
    if (lsUrl) return lsUrl.replace(/\/$/, '');
  }

  /** Satu server: API di domain yang sama (unified server), tanpa URL terpisah. */
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api/v1`;
  }

  return '';
}

function resolveApiKey(): string {
  if (typeof localStorage !== 'undefined') {
    const lsKey = localStorage.getItem(LS_KEY_KEY)?.trim();
    if (lsKey) return lsKey;
  }
  return BUILTIN_API_KEY;
}

export function getCentralDbConfig(): CentralDbConfig | undefined {
  const baseUrl = resolveBaseUrl();
  const apiKey = resolveApiKey();
  if (!baseUrl || !apiKey) return undefined;
  return { baseUrl, apiKey };
}

export function isCentralDbEnabled(): boolean {
  return Boolean(getCentralDbConfig());
}

export function getDefaultCentralDbUrl(): string {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api/v1`;
  }
  return '/api/v1';
}

export function setCentralDbConfigOverride(url: string, apiKey: string) {
  if (typeof localStorage === 'undefined') return;
  const u = url.trim().replace(/\/$/, '');
  const k = apiKey.trim();
  if (u) localStorage.setItem(LS_URL_KEY, u);
  else localStorage.removeItem(LS_URL_KEY);
  if (k) localStorage.setItem(LS_KEY_KEY, k);
  else localStorage.removeItem(LS_KEY_KEY);
}

export function clearCentralDbConfigOverride() {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(LS_URL_KEY);
  localStorage.removeItem(LS_KEY_KEY);
}
